import Paper from '@mui/material/Paper';
import { TextField,Button } from '@mui/material';
import { useState } from 'react';
import axios from "axios";
import React from 'react';
import CompanySelect from '../Universal/CompanySelect';
import DialogMessage from '../Universal/DialogMessage';
import CreateIcon from '@mui/icons-material/Create';


function Users(props)
{

    const [userId,setUserId]=useState(0);
    const [userName,setUserName]=useState("");
    const [selectedCompany,setSelectedCompany]=useState(0);
    const [emailError,setEmailError]=useState('');
    const [emailErrorMessage,setEmailErrorMessage]=useState('');
    const [showDialog,setShowDialog]=useState(false);
    //Axios up all the companies

    

    const submit=()=>{
        //Check the email
        if (!userName || !/\S+@\S+\.\S+/.test(userName)) {
            setEmailError(true);
            setEmailErrorMessage('Please enter a valid email address.');
          } else {
            setEmailError(false);
            setEmailErrorMessage('');
            axios({
                // Endpoint to send files
                url: process.env.REACT_APP_API_URL+'user',
                method: "POST",
                data:{ email : userName,
                    companyId:selectedCompany
                 },
                headers: {
                    // Add any auth token here
                    //authorization: "your token comes here",
                },
            }).then((res) => {
                //Nothing to do
            }).catch((err) => {
                console.log(err)
            });
            setUserName('');
            setSelectedCompany(0);
            setShowDialog(true);
          }
    };
    const onChange=()=>{};

    return(
            <>
            <div className='container'>
                <h4>New User</h4>
                            {/* Add user */}
                            <div className='formRow'>
                                <div className='formGroup'>
                                <TextField id="standard-basic" label="User Email" variant="outlined" onChange={(e)=>{setUserName(e.target.value)}} value={userName}
                                error={emailError}
                                helperText={emailErrorMessage}
                                className='formControl'
                                />
                                </div>
                                <div className='formGroup'></div>
                                <div className='formGroup'></div>
                            </div>
                            <div className='formRow'>
                                <div className='formGroup'>
                                    <CompanySelect className='formControl' 
                                        selectedCompany={selectedCompany}   
                                        setSelectedCompany={setSelectedCompany} 
                                        showAllCompanies={true} 
                                        allCompanies={props.allCompanies} 
                                        onChange={onChange} 
                                        selectText='User Company' 
                                        headerText=''></CompanySelect></div>
                                <div className='formGroup'></div>
                                <div className='formGroup'></div>
                            </div>                            
                            <div className='formRow'>
                                <div className='formGroup'>
                                    <Button startIcon={<CreateIcon/>} variant="outlined" color="info" onClick={submit}>Create User</Button>
                                    </div>
                                <div className='formGroup'></div>
                                <div className='formGroup'></div>
                            </div>
                                
                    <DialogMessage open={showDialog} setOpen={setShowDialog} title="User Created" message='The user has been created with a default password matching their email.'/>
                    </div>
            </>
        );
    }

export default Users;